/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListCourseStudentData } from './genericApiResponseListCourseStudentData';
import type { GenericApiResponseListCourseStudentMessage } from './genericApiResponseListCourseStudentMessage';
import type { GenericApiResponseListCourseStudentPagination } from './genericApiResponseListCourseStudentPagination';
import type { GenericApiResponseListCourseStudentError } from './genericApiResponseListCourseStudentError';

export interface GenericApiResponseListCourseStudent {
  data?: GenericApiResponseListCourseStudentData;
  message?: GenericApiResponseListCourseStudentMessage;
  pagination?: GenericApiResponseListCourseStudentPagination;
  error?: GenericApiResponseListCourseStudentError;
  statusCode?: number;
}
